<template>
  <article class="">
    <template v-if="isLoading">
      <p class="text-h6 is-4">
        Loading...
        <i class="fa fa-refresh fa-spin fa-fw" />
      </p>
    </template>
    <template v-else>
      <template v-if="themeUpdateLogs.length">
        <div style="min-height: 530px">
          <table class="table">
            <thead>
              <tr>
                <th class="date">Date</th>
                <th>Theme</th>
                <th>User</th>
                <th>Action</th>
                <th>From</th>
                <th>To</th>
                <th>Success</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in themeUpdateLogs">
                <td>{{ log.createdAt | dateFormat }}</td>
                <td>{{ log.themeName }}</td>
                <td>{{ log.userFirstName }} {{ log.userLastName }}</td>
                <td>{{ log.action }}</td>
                <td>{{ log.currentVersion }}</td>
                <td>{{ log.newVersion }}</td>
                <td>{{ log.success ? 'Yes' : 'No' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <paginator
          :page-list="pages.pageList"
          :current-page="Number(pages.currentPage)"
          :num-pages="Number(pages.numPages)"
          @loadPage="get"
        ></paginator>
      </template>

      <p v-else class="p-3 h6">
        <span style="display: block">
          You haven't given this site any love yet. Go ahead and update a theme now (scroll up). There’s no time like
          the present...
        </span>
        <random-gif />
      </p>
    </template>
  </article>
</template>

<script>
// import Message from 'vue-bulma-message'
import { buildEndpoint } from '../../libs/buildEndPoint';
import Paginator from './Paginator';
import RandomGif from './random-gif';

export default {
  components: {
    // Message,
    Paginator,
    RandomGif,
  },

  props: {
    site: Object,
    doRefresh: Number,
  },
  data() {
    return {
      error: null,
      themeUpdateLogs: [],
      isLoading: false,
      pages: {},
    };
  },

  created() {
    this.get();
  },
  mounted() {
    this.$watch(
      'doRefresh',
      (doRefresh) => {
        this.get();
      },
      { immediate: true },
    );
  },
  methods: {
    get(pageNum) {
      pageNum = pageNum || 1;
      this.isLoading = true;
      this.error = null;
      this.$http
        .get(`${buildEndpoint('theme-update-logs/') + this.site._id}?page=${pageNum}`)
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            const { data } = response.data;
            this.themeUpdateLogs = data.docs;
            const pageList = [];
            for (let i = 1; i <= data.pages; i++) {
              if (i > data.page - 5 && i < data.page + 5) {
                pageList.push(i);
              }
            }
            this.pages = {
              numPages: data.pages,
              currentPage: data.page,
              totalDocs: data.total,
              pageList,
            };
          } else {
            this.error = 'Error getting log data';
          }
        })
        .catch((error) => {
          this.error = error;
        });
    },
  },
};
</script>

<style lang="scss" scoped="">
table {
  .date {
    width: 200px;
  }
}
.refresh-site {
  border: none;
  &:focus {
    border: none;
    box-shadow: none;
  }
  color: silver;
}
.rollback-buttons {
  float: right;
}
</style>
